module.exports = __webpack_public_path__ + "static/media/bot.eeb14391.png";